<div class="overlay">
    <!-- #region FORM TITLE -->
    <div class="add-contact-popup">
        <div class="popup-head">
            <button class="close-btn-mobile" (click)="sendStatus()"><img src="assets/icons/cancel-white.svg"
                    alt=""></button>
            <img src="assets/icons/join_logo.svg" alt="Join Logo">
            <h1>Add contact</h1>
            <h4>Tasks are better with a team!</h4>
            <div></div>
        </div>
    <!-- #endregion -->
    <!-- #region EMPTY FORM -->
        <div class="popup-form">
            <button class="close-btn" (click)="sendStatus()"><img src="assets/icons/cancel.svg" alt=""></button>
            <div class="person-img">
                <img src="assets/icons/person.svg" alt="person">
            </div>
            <form (ngSubmit)="onSubmit(contactForm)" #contactForm="ngForm">
                <!-- #region NAME -->
                <div class="input-wrapper">
                    <input #name="ngModel" appPatternValidator="generalName" [(ngModel)]="contactData.name" type="text" placeholder="Name" name="name"
                        required (ngModelChange)="formatName($event)" [ngStyle]="{'border-color': !name.valid && name.touched ? 'red' : '#D9D9D9'}"><img
                        src="assets/icons/person-gray.svg" alt="">
                    @if (name.touched){
                        @if (name.hasError('required')){
                            <span>Name is required.</span>
                        } @else if (name.hasError('invalidPattern')) {
                            <span>No numbers, ,,.,#,*,!,$,%,&,\,/,_,",?,~,=,;,:</span>
                        }
                    }
                </div>
                <!-- #endregion -->
                <!-- #region EMAIL -->
                <div class="input-wrapper">
                    <input #mail="ngModel" [(ngModel)]="contactData.email"
                        [ngStyle]="{'border-color': !mail.valid && mail.touched ? 'red' : '#D9D9D9'}" type="email"
                        placeholder="Email" name="email" required
                        appPatternValidator="emailFormat"><img src="assets/icons/mail.svg"
                        alt="">
                    @if (mail.touched){
                        @if(mail.hasError('required')){
                            <span>Email address is required.</span>
                        } @else if (mail.hasError('invalidPattern')) {
                            <span>Please enter a valid email address!</span>
                        }
                    }
                </div>
                <!-- #endregion -->
                <!-- #region PHONE -->
                <div class="input-wrapper">
                    <input #phone="ngModel" appPatternValidator="phoneFormat" [(ngModel)]="contactData.phone" type="text" placeholder="Phone" name="phone"
                        required [ngStyle]="{'border-color': !phone.valid && phone.touched ? 'red' : '#D9D9D9'}"><img
                        src="assets/icons/phone.svg" alt="">
                    @if (phone.touched){
                        @if(phone.hasError('required')){
                            <span>Phone number is required</span>
                        }@else if (phone.hasError('invalidPattern')) {
                            <span>Please enter a valid number!</span>
                        }
                    }
                </div>
                <!-- #endregion -->
                <!-- #region CANCEL & SUBMIT BUTTON -->
                <div class="btn-wrapper">
                    <button class="cancel-btn" (click)="sendStatus()">Cancel

                        <svg class="cancel-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M6 6L18 18M6 18L18 6" />
                        </svg>

                    </button>
                    <div class="submit-wrapper">
                        <input type="submit" value="Create contact">
                        <img src="assets/icons/check.svg" alt="check-img">
                    </div>
                </div>
                <!-- #endregion -->
            </form>
        </div>
        <!-- #endregion -->
    </div>
</div>
<div class="loading-screen" [ngStyle]="{'display' : !loadingActive ? 'none' : 'block'}"></div>